import { Box, Text } from '@mantine/core';
import { PRIMARY_OPACITY_80 } from '../../../../constants/colors';


interface Component {
  _id: string;
  name: string;
  [key: string]: any;
}

interface CenterCellProps {
  record: Component;
  isModalOpen: boolean;
}

export function CenterCell({ record, isModalOpen }: CenterCellProps) {
  if (isModalOpen) return null;

  return (
    <Box 
      sx={{ 
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        left: '58%',
        zIndex: 1000
      }}>
      <Text
        color={PRIMARY_OPACITY_80}
        lineClamp={1}
      >{record.name}
      </Text>
    </Box>
  );
} 